import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { FormattedMessage } from 'react-intl';
import { SecondaryGhostButton } from '@bibliocommons/base-buttons';
import { UserCircle } from '@bibliocommons/base-icons';
import { Pill } from 'app/components/shared/Pill';
import { selectTagsByBibs } from 'app/selectors/ugc/TagsSelector';
import TagsEditor from 'app/components/bibs/shared/ugc/TagsEditor';
import { TAG_TYPES } from 'app/constants/TagsConstants';

import './AddTags.scss';
import { useSelector } from 'react-redux';

export default function AddTags({ metadataId, tagsActions }) {
  const [open, setOpen] = useState(false);
  const ownerTags = useSelector(selectTagsByBibs).get(metadataId, Immutable.Map());

  function openTagEditor() {
    setOpen(true);
  }

  function closeEditor() {
    setOpen(false);
  }

  function handleRemoveTag(tag) {
    return tagsActions.removeTag(metadataId, tag.get('id'), tag.get('type'));
  }

  function renderTagEditor() {
    if (!open) return null;

    return <TagsEditor metadataId={metadataId} handleClose={closeEditor} tagsActions={tagsActions} />;
  }

  function renderAddTagsButton() {
    if (open) return null;

    return (
      <SecondaryGhostButton className="add-tags-button" dataKey="add-tags-button" handleClick={openTagEditor}>
        <FormattedMessage id="add_and_remove_tags" />
      </SecondaryGhostButton>
    );
  }

  function renderMyTags() {
    if (open || !ownerTags.size) return null;

    return (
      <div className="my-tags">
        <div className="my-tags-heading">
          <FormattedMessage id="my_tags_text" />
        </div>
        <ul className="my-tags-list">
          {ownerTags?.map(tag => (
            <Pill
              className={tag.get('type') === TAG_TYPES.PERSONAL ? 'tag-pill-personal' : ''}
              key={tag.get('id')}
              handleDismiss={() => handleRemoveTag(tag)}
              icon={tag.get('type') === TAG_TYPES.PERSONAL ? <UserCircle /> : null}
            >
              {tag.get('value')}
            </Pill>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="cp-add-tags">
      {renderAddTagsButton()}
      {renderMyTags()}
      {renderTagEditor()}
    </div>
  );
}

AddTags.propTypes = {
  metadataId: PropTypes.string.isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired
};
